/**
 * Generates blob from the URL and convert it into blobURL
 *
 * @param url required to get the blob and convert it to blob URL
 * @param type stores image type for dataURL for particular format encoding
 */

import generateBlob from './generateBlob';
import generateObjectURL from './generateObjectURL';

export default async (url, type) => {
  const blob = new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = () => {
      const canvas = document.createElement('CANVAS');
      const ctx = canvas.getContext('2d');
      canvas.height = img.naturalHeight;
      canvas.width = img.naturalWidth;
      ctx.drawImage(img, 0, 0);
      resolve(generateBlob(canvas, type));
    };
    img.src = url;
  });

  // Converts blob to blobURL
  const blobURL = generateObjectURL(await blob);
  return blobURL;
};
